import { Phone, Mail } from "lucide-react";
import { Eyebrow, PrimaryButton, Reveal } from "@/components/ui-bits";

const WhyClosing = () => {
  return (
    <section data-testid="why-closing-section" aria-labelledby="why-closing-heading" className="bg-[#191c1e] py-16 text-white sm:py-20 lg:py-24">
      <div className="container-30 grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <Eyebrow light>Why 30 NORTH</Eyebrow>
          <h2
            id="why-closing-heading"
            data-testid="why-closing-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl"
          >
            LET'S MOVE YOUR FREIGHT FORWARD.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
            Experienced coordination. Clear communication. Practical transportation solutions. One focus: moving your
            freight forward.
          </p>
          <div className="mt-10">
            <PrimaryButton to="/request-a-quote" testid="why-closing-cta">
              REQUEST A QUOTE
            </PrimaryButton>
          </div>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-5">
          <div className="border border-[#2b2f33] bg-[#121416] p-8 lg:p-10" data-testid="why-closing-contact">
            <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-white/40">Contact 30 NORTH</h3>
            <a
              href="tel:6138700294"
              data-testid="why-closing-phone"
              className="mt-6 flex items-center gap-4 text-white transition-colors duration-200 hover:text-[#ff6a00]"
            >
              <Phone className="h-5 w-5 shrink-0 text-[#ff6a00]" aria-hidden="true" />
              <span className="font-display text-xl font-bold tracking-wide sm:text-2xl">613-870-0294</span>
            </a>
            <a
              href="mailto:operations@30north.ca"
              data-testid="why-closing-email"
              className="mt-5 flex items-center gap-4 text-white/80 transition-colors duration-200 hover:text-[#ff6a00]"
            >
              <Mail className="h-5 w-5 shrink-0 text-[#ff6a00]" aria-hidden="true" />
              <span className="break-all text-base font-medium">operations@30north.ca</span>
            </a>
            <p className="mt-8 border-t border-[#2b2f33] pt-6 text-sm leading-relaxed text-white/50">
              2907 - 80 Absolute Ave
              <br />
              Mississauga, ON L4Z 0A5
              <br />
              Canada
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default WhyClosing;
